import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  DECIMAL_PATTERN,
  EMAIL_PATTERN,
  NAME_PATTERN,
} from "src/app/shared/app.regexs";
import { RutValidator } from "ng9-rut";
import { ConfirmationlValidator } from "src/app/shared/validators/confirmation.validators";
import { Subscription } from "rxjs";
import { MapsAPILoader } from "@agm/core";
import { IMAGE_FORMAT_ACEPT } from "src/app/app.constants";
import { ClienteExpressService } from "src/app/core/services/cliente-express.service";
import { environment } from "src/environments/environment";
import { IFileUpload } from "src/app/core/models/file-upload.interface";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ModalAvisoComunasComponent } from "../modal-aviso-comunas/modal-aviso-comunas.component";
import { customMinValidator } from "src/app/shared/validators/custom-min.validators";
import { Router } from "@angular/router";
import { maxDecimalValidator } from "src/app/shared/validators/max-decimal.validator";

@Component({
  selector: "app-express-retail-form",
  templateUrl: "./express-retail-form.component.html",
  styleUrls: ["./express-retail-form.component.scss"],
})
export class ExpressRetailFormComponent implements OnInit, OnDestroy {
  @ViewChild("search", { static: false }) public search: ElementRef | undefined;
  @ViewChild("searchFact", { static: false }) public searchFact: ElementRef | undefined;

  @Input() comunas: any[] = [];

  public isLoading = false;
  public isError = false;

  public paginaActual = 1; // Aquiiiiiiiiiiiiiiiiii
  public infoPersonalForm: FormGroup | undefined;
  public infoDespachoForm: FormGroup | undefined;
  public infoFacturacionForm: FormGroup | undefined;
  public isSubmitted = {
    infoPersonal: false,
    infoDespacho: false,
    infoFacturacion: false,
  };



  public tiposEstanque: any[] = [];
  public tiposVentansHorarias: any[] = [];
  public tiposSegmentos: any[] = [];

  private obsRecibeChange: Subscription | undefined;
  private obsCapEstanqueChange: Subscription | undefined;
  private obsTipoEstanqueChange: Subscription | undefined;
  private obsTipoClienteChange: Subscription | undefined;
  private obsTipoDirecFaceChange: Subscription | undefined;
  private obsDireccionChange: Subscription | undefined;
  private obsRegionChange: Subscription | undefined;
  private obsProvinciaChange: Subscription | undefined;
  private obsComunaChange: Subscription | undefined;
  public imagesAcept = IMAGE_FORMAT_ACEPT;

  public isShowCertificacionCapacidadEstanque = false;
  public isShowTipoTanqueEstanque = false;

  googleCaptchaSiteKey = environment.googleCaptchaSiteKey;
  googleCaptchaResponse: string;

  public filelistFotosEstanque: IFileUpload[] = [];
  public filelistCapacidadEstanque: IFileUpload[] = [];
  public filelistTipoEstanque: IFileUpload[] = [];

  public errorFilesDespacho = {
    fotosEstanque: false,
    capacidadEstanque: false,
    tipoEstanque: false,
  };

  public modalComunasRef: MatDialogRef<ModalAvisoComunasComponent>;

  private geoCoder: any;
  public latitude: any;
  public longitude: any;
  public lat: any = -33.44163005208342;
  public lng: any = -70.65402580802244;
  public zoom: any = 15;
  public map: any;
  public mapClickListener: any;
  public haveCurrentLocation = false;

  private geoCoderFac: any;
  public latFac: any = -33.44163005208342;
  public lngFac: any = -70.65402580802244;
  public latitudeFac: any;
  public longitudeFac: any;


  constructor(
    private formBuilder: FormBuilder,
    private rutValidator: RutValidator,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private clienteExpressService: ClienteExpressService,
    public dialog: MatDialog,
    private router: Router,
  ) {
    this.infoPersonalForm = this.formBuilder.group({
      nombre: [
        undefined,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(50),
          Validators.pattern(NAME_PATTERN),
        ],
      ],
      rut: [undefined, [Validators.required, this.rutValidator]],
      email: [
        undefined,
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(EMAIL_PATTERN),
        ],
      ],
      confirmEmail: [
        undefined,
        [
          Validators.required,
          Validators.maxLength(75),
          Validators.pattern(EMAIL_PATTERN),
          ConfirmationlValidator("email"),
        ],
      ],
      celular: [
        undefined,
        [Validators.required, Validators.maxLength(9), Validators.minLength(9)],
      ],
      confirmCelular: [
        undefined,
        [
          Validators.required,
          Validators.maxLength(9),
          Validators.minLength(9),
          ConfirmationlValidator("celular"),
        ],
      ],
    });

   
    this.infoDespachoForm = this.formBuilder.group({
      direccion: [undefined, [Validators.required]],
      region: [undefined, [Validators.required, Validators.maxLength(50), Validators.pattern(NAME_PATTERN)]],
      cuidad: [undefined, [Validators.required, Validators.maxLength(50), Validators.pattern(NAME_PATTERN)]],
      comuna: [undefined, [Validators.required, Validators.maxLength(50), Validators.pattern(NAME_PATTERN)]],
      observacion: [undefined, [Validators.maxLength(150)]],
      distanciaCamion: [
        undefined,
        [
          Validators.required,
          Validators.min(1),
          maxDecimalValidator(15),
          Validators.pattern(DECIMAL_PATTERN),
        ],
      ],
      // capacidadEstanque: [undefined, [Validators.required, Validators.min(200)]],
      capacidadEstanque: [undefined, [Validators.required, customMinValidator(200)]],
      tipoEstanque: [undefined, [Validators.required]],
      ventanaHoraria: [undefined, [Validators.required]],
      quienRecibe: ["yo"],
      nombreRecibe: [
        undefined,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(50),
          Validators.pattern(NAME_PATTERN),
        ],
      ],
      celularRecibe: [
        undefined,
        [Validators.required, Validators.maxLength(9), Validators.minLength(9)],
      ],
    });

    this.infoFacturacionForm = this.formBuilder.group({
      tipoPersona: ['Persona natural', [Validators.required]],
      razonSocial: [
        undefined,
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(NAME_PATTERN),
        ],
      ],
      rut: [undefined, [Validators.required, this.rutValidator]],
      mismaDireccion: [undefined],
      direccion: [undefined, [Validators.required]],
      giro: [
        undefined,
        [
          Validators.required,
          Validators.maxLength(50),
          Validators.pattern(NAME_PATTERN),
        ],
      ],
      segmento: [undefined, [Validators.required]],
      terminos: [undefined, [Validators.required, Validators.requiredTrue]],
      recaptchaReactive: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.getTipoEstanque();
    this.getVentanaHoraria();
    this.getSegmentos();

    this.obsRecibeChange = this.infoDespachoForm
      .get('quienRecibe')
      .valueChanges.subscribe((value: string) => {
        if (value === 'yo') {
          this.setRecibeData();
        } else if (value === 'otro') {
          this.infoDespachoForm.get('nombreRecibe').enable();
          this.infoDespachoForm.get('celularRecibe').enable();

          this.infoDespachoForm.get('nombreRecibe').setValue('');
          this.infoDespachoForm.get('celularRecibe').setValue('');
        }
      });
      
      this.obsCapEstanqueChange = this.infoDespachoForm.get('capacidadEstanque').valueChanges.subscribe((value: string) => {
        const totalEstanque = value.replace(/\./g, '');
        this.isShowCertificacionCapacidadEstanque = (Number(totalEstanque) >= 1000);
      });
      
      this.obsTipoEstanqueChange = this.infoDespachoForm.get('tipoEstanque').valueChanges.subscribe((value: any) => {
        this.isShowTipoTanqueEstanque = value?.descripcion === 'Enterrado';        
      });

      this.obsTipoClienteChange = this.infoFacturacionForm
        .get('tipoPersona')
        .valueChanges.subscribe((value: string) => {
          if (value === 'Persona natural') {
            this.setRazonSolcial();
          } else if (value === 'Comercial') {
            this.infoFacturacionForm.get('razonSocial').enable();
            this.infoFacturacionForm.get('rut').enable();
  
            this.infoFacturacionForm.get('razonSocial').setValue('');
            this.infoFacturacionForm.get('rut').setValue('');

            this.infoFacturacionForm.get('giro').enable();
            this.infoFacturacionForm.get('segmento').enable();

            this.infoFacturacionForm.get('giro').setValue('');
            this.infoFacturacionForm.get('segmento').setValue(undefined);
    
          }
        });

      this.obsTipoDirecFaceChange = this.infoFacturacionForm.get('mismaDireccion').valueChanges.subscribe((value: boolean) => {        
        if (value) {
          this.infoFacturacionForm.get('direccion').setValue(this.infoDespachoForm.get('direccion').value);
          this.infoFacturacionForm.get('direccion').disable();
        } else {
          this.infoFacturacionForm.get('direccion').enable();
          this.infoFacturacionForm.get('direccion').setValue('');
        }
      });
  }

  ngOnDestroy(): void {
    this.obsRecibeChange?.unsubscribe();
    this.obsCapEstanqueChange?.unsubscribe();
    this.obsTipoEstanqueChange?.unsubscribe();
    this.obsTipoClienteChange?.unsubscribe();
    this.obsTipoDirecFaceChange?.unsubscribe();
    this.obsDireccionChange?.unsubscribe();
    this.obsRegionChange?.unsubscribe();
    this.obsProvinciaChange?.unsubscribe();
    this.obsComunaChange?.unsubscribe();
  }

  get ipf(): any {
    return this.infoPersonalForm?.controls;
  }

  get idf(): any {
    return this.infoDespachoForm?.controls;
  }

  get iff(): any {
    return this.infoFacturacionForm?.controls;
  }

  public handleChangeAddress() {
    const direccion = this.infoDespachoForm.get('direccion').value;
    const region = this.infoDespachoForm.get('region').value;
    const cuidad = this.infoDespachoForm.get('cuidad').value;
    const comuna = this.infoDespachoForm.get('comuna').value;

    if (direccion && region && cuidad && comuna) {
      const address = `${direccion}, ${comuna}, ${region}`;

      this.geoCoder.geocode({ address }, (results, status) => {
        if (status === 'OK' && results[0]) {
          const { lat, lng } = results[0].geometry.location;
          console.log('Coordenadas:', { lat: lat(), lng: lng() });


          this.latitude = lat();
          this.longitude = lng();
          this.lat = lat();
          this.lng = lng();

        } else {
          console.error('No se pudo geocodificar la dirección:', status);
        }
      });
    }
  }

  public handleChangeComuna() {
    
    this.handleChangeAddress();
    const intComuna = this.infoDespachoForm.get('comuna').value;

    console.log('🚀 ~ ExpressRetailFormComponent ~ handleChangeComuna ~ intComuna:', intComuna);
 
    if (intComuna) {
      this.validarComuna(intComuna);
    }
  }

  public validarComuna(comunaName: string) {
    let findComuna = false;

    if (comunaName) {
      const inComunaName = comunaName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      findComuna = this.comunas.find((com: any) => {
        const localComunaName = com.comuna.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        return localComunaName === inComunaName
      });
    }
   

    if (!findComuna) {
      this.modalComunasRef = this.dialog.open(ModalAvisoComunasComponent, {
        width: "800px",
        data: {
          comunas:
            this.comunas
        },
      });
    }
    return !!findComuna;
    
  }

  public mapReadyHandler(map: google.maps.Map): void {    
    const mapClickListener = map.addListener(
      'click',
      (e: google.maps.MouseEvent) => {
        this.ngZone.run(() => {
          // Here we can get correct event
          this.latitude = e.latLng.lat();
          this.longitude = e.latLng.lng();
          this.getAddress(this.latitude, this.longitude, true);
        });
      }
    );
  }

  public mapReadyHandlerFac(map: google.maps.Map): void {    
    const mapClickListener = map.addListener(
      'click',
      (e: google.maps.MouseEvent) => {
        this.ngZone.run(() => {
          // Here we can get correct event
          this.latitudeFac = e.latLng.lat();
          this.longitudeFac = e.latLng.lng();
          this.getAddressFac(this.latitudeFac, this.longitudeFac, true);
        });
      }
    );
  }

  public getAddress(latitude: any, longitude: any, emitEvent?: boolean): void {
    if (typeof emitEvent === 'undefined') {
      emitEvent = true;
    }

    let resultado;
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results: any, status: any) => {
        if (status === 'OK') {
          if (results[0]) {
            resultado = results[0];
            this.zoom = 15;
            this.infoDespachoForm.get('direccion').setValue(results[0].formatted_address, { emitEvent });
          } else {
            console.error('No results found');
          }
        } else {
          if (status !== 'OVER_QUERY_LIMIT') {
            console.error('Geocoder failed due to: ' + status);
          }
        }
      }
    );

    setTimeout(() => {
      if (resultado) {
        this.getAdreesComponents(resultado.address_components, true);
      }
    }, 500);
   
  }


  public getAddressFac(latitude: any, longitude: any, emitEvent?: boolean): void {
    if (typeof emitEvent === 'undefined') {
      emitEvent = true;
    }

    let resultado;
    this.geoCoderFac.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results: any, status: any) => {
        if (status === 'OK') {
          if (results[0]) {
            resultado = results[0];
            this.zoom = 15;
            console.log('se pasa po', results[0].formatted_address)
            this.infoFacturacionForm.get('direccion').setValue(results[0].formatted_address, { emitEvent });
          } else {
            console.error('No results found');
          }
        } else {
          if (status !== 'OVER_QUERY_LIMIT') {
            console.error('Geocoder failed due to: ' + status);
          }
        }
      }
    );

    // setTimeout(() => {
    //   if (resultado) {
    //     this.getAdreesComponents(resultado.address_components, true);
    //   }
    // }, 500);
   
  }

  private setCurrentLocation(setAdress?: boolean): void {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.lat = position.coords.latitude;
          this.lng = position.coords.longitude;
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          this.haveCurrentLocation = true;
          if (setAdress) {
            this.getAddress(this.lat, this.lng, true);
          }
        }
      );
    }
  }

  public markerDragEnd($event: any): void {
    this.latitude = $event.latLng.lat();
    this.longitude = $event.latLng.lng();
    this.lat = $event.latLng.lat();
    this.lng = $event.latLng.lng();
    this.getAddress(this.latitude, this.longitude, true);
  }

  public markerDragEndFac($event: any): void {
    this.latitudeFac = $event.latLng.lat();
    this.longitudeFac = $event.latLng.lng();
    this.latFac = $event.latLng.lat();
    this.lngFac = $event.latLng.lng();
    this.getAddressFac(this.latitudeFac, this.longitudeFac, true);
  }











  private async getTipoEstanque() {
    try {      
      const response = await this.clienteExpressService.getTipoEstanque();
      this.tiposEstanque = response.items;

    } catch (error) {
      console.error('Error al llamar al servicio');
    }
  }

  private async getVentanaHoraria() {
    try {      
      const response = await this.clienteExpressService.getVentanaHoraria();
      this.tiposVentansHorarias = response.items;
      if (this.tiposVentansHorarias.length === 1) {
        this.infoDespachoForm.get('ventanaHoraria').setValue(this.tiposVentansHorarias[0]);
      }
    } catch (error) {
      console.error('Error al llamar al servicio');
    }
  }

  private async getSegmentos() {
    try {      
      const response = await this.clienteExpressService.getSegmentos();
      console.log('🚀 ~ ExpressRetailFormComponent ~ getSegmentos ~ response:', response);
      this.tiposSegmentos = response.items;

    } catch (error) {
      console.error('Error al llamar al servicio');
    }
  }

  private setRecibeData() {
    if (this.infoDespachoForm.get('quienRecibe').value === 'yo') {
      this.infoDespachoForm.get('nombreRecibe').setValue(this.infoPersonalForm.get('nombre').value);
      this.infoDespachoForm.get('celularRecibe').setValue(this.infoPersonalForm.get('celular').value);

      this.infoDespachoForm.get('nombreRecibe').disable();
      this.infoDespachoForm.get('celularRecibe').disable();
    }
  }

  private setRazonSolcial() {
    if (this.infoFacturacionForm.get('tipoPersona').value === 'Persona natural') {
      this.infoFacturacionForm.get('razonSocial').setValue(this.infoPersonalForm.get('nombre').value);
      this.infoFacturacionForm.get('rut').setValue(this.infoPersonalForm.get('rut').value);
  
      this.infoFacturacionForm.get('razonSocial').disable();
      this.infoFacturacionForm.get('rut').disable();
  
  
      this.infoFacturacionForm.get('giro').setValue('Ventas al por menor de combustible');
      this.infoFacturacionForm.get('segmento').setValue('Ventas al por menor de combustible');
  
      this.infoFacturacionForm.get('giro').disable();
      this.infoFacturacionForm.get('segmento').disable();
    }
  }

  private async loadMapDespacho(): Promise<void> {
    await this.mapsAPILoader.load();
    this.geoCoder = new google.maps.Geocoder();
    const autocomplete = new google.maps.places.Autocomplete(
      this.search?.nativeElement
    );

    // this.setCurrentLocation(true);

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }
        this.getAdreesComponents(place.address_components, true);

        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.lat = place.geometry.location.lat();
        this.lng = place.geometry.location.lng();

        this.infoDespachoForm
          .get("direccion")
          ?.setValue(place.formatted_address, { emitEvent: false });
      });
    });
  }
     

  private async loadMapFacturacion(): Promise<void> {
    await this.mapsAPILoader.load();
    this.geoCoderFac = new google.maps.Geocoder();

    console.log('this.searchFact', this.searchFact);

    const autocomplete = new google.maps.places.Autocomplete(
      this.searchFact?.nativeElement
    );

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.latitudeFac = place.geometry.location.lat();
        this.longitudeFac = place.geometry.location.lng();
        this.latFac = place.geometry.location.lat();
        this.lngFac = place.geometry.location.lng();

        this.infoFacturacionForm
          .get("direccion")
          ?.setValue(place.formatted_address, { emitEvent: false });
      });
    });
  }


  public getAdreesComponents(adressComponents: any[], validateComuna?: boolean) {
    const region = adressComponents.find((o: any) =>
      o.types.includes("administrative_area_level_1")
    );
    
    this.infoDespachoForm
      .get("region")
      ?.setValue(region?.long_name, { emitEvent: false });

    const ciudad = adressComponents.find((o: any) =>
      o.types.includes("administrative_area_level_2")
    );
   
    this.infoDespachoForm
      .get("cuidad")
      ?.setValue(ciudad?.long_name, { emitEvent: false });

    const comuna = adressComponents.find((o: any) =>
      o.types.includes("administrative_area_level_3")
    );

    if (validateComuna) {
      if (this.validarComuna(comuna?.long_name)) {
        this.infoDespachoForm
        .get("comuna")
        ?.setValue(comuna?.long_name, { emitEvent: false });
      } else {
        this.infoDespachoForm
        .get("comuna")
        ?.setValue(undefined, { emitEvent: false });
      }
    } else {
      this.infoDespachoForm
        .get("comuna")
        ?.setValue(comuna?.long_name, { emitEvent: false });
    }    
  }


  resolved(event) {
    this.googleCaptchaResponse = event;
    //console.log("RESPUESTA RECAPTCHA: ", event);
  }



  public setFotosEstanque(files: IFileUpload[]) {
    this.filelistFotosEstanque = files;
    this.validateDespachoFiles();
  }

  public setCapacidadEstanque(files: IFileUpload[]) {
    this.filelistCapacidadEstanque = files;
    this.validateDespachoFiles();
  }

  public setTipoEstanque(files: IFileUpload[]) {
    this.filelistTipoEstanque = files;
    this.validateDespachoFiles();
  }


  public handleSubmitInfoPersonal() {
    this.isSubmitted.infoPersonal = true;
    this.infoPersonalForm?.markAllAsTouched();
    if (this.infoPersonalForm?.valid && this.infoPersonalForm) {
      this.paginaActual = 2;
      this.setRecibeData();
      setTimeout(() => {
        this.loadMapDespacho();
      }, 100);
    }
  }

  public handleSubmitInfoDespacho() {
    this.isSubmitted.infoDespacho = true;
    this.infoDespachoForm?.markAllAsTouched();
    if (this.infoDespachoForm?.valid && this.infoDespachoForm && this.validateDespachoFiles()) {
      this.paginaActual = 3;
      this.setRazonSolcial();
      setTimeout(() => {
        this.loadMapFacturacion();
      }, 100);

    }
  }

  public async handleSubmitInfoFacturacion() {
    this.isSubmitted.infoFacturacion = true;
    this.infoFacturacionForm?.markAllAsTouched();
    this.isError = false;
    if (this.infoFacturacionForm?.valid && this.infoFacturacionForm) {


      const bodyInfoPersonal = {
        rut: this.infoPersonalForm.get('rut').value?.replace(/\./g, ''),
        nombre: this.infoPersonalForm.get('nombre').value,
        telefono: `+56${this.infoPersonalForm.get('celular').value}`,
        mail: this.infoPersonalForm.get('email').value,
      }

      // Despacho
      let nombreRecibe = this.infoPersonalForm.get('nombre').value;
      let celularRecibe = `+56${this.infoPersonalForm.get('celular').value}`;

      if (this.infoDespachoForm.get('quienRecibe').value === 'otro') {
        nombreRecibe = this.infoDespachoForm.get('nombreRecibe').value;
        celularRecibe = `+56${this.infoDespachoForm.get('celularRecibe').value}`;
      }   

      const bodyInfoDespacho: any = {
        direccion: this.infoDespachoForm.get('direccion').value,
        cuidad: this.infoDespachoForm.get('cuidad').value,
        comuna: this.infoDespachoForm.get('comuna').value,
        region: this.infoDespachoForm.get('region').value,
        observaciones:  this.infoDespachoForm.get('observacion').value,
        latitud: this.latitude,
        longitud: this.longitude,
        distanciaCamionEstanque: Number(this.infoDespachoForm.get('distanciaCamion').value?.replace(/\,/g, '.')),
        capacidadEstanque: Number(this.infoDespachoForm.get('capacidadEstanque').value?.replace(/\./g, '')),
        archivoFotoEstanque: {
          nombre: this.filelistFotosEstanque[0]?.name,
          tipo: this.filelistFotosEstanque[0]?.nativeFile?.type,
        },
        tipoEstanque: this.infoDespachoForm.get('tipoEstanque').value?.descripcion,
        ventanaHoraria: this.infoDespachoForm.get('ventanaHoraria').value?.descripcion,
        nombreQuienRecibe: nombreRecibe,
        telefonoQuienRecibe: celularRecibe
      }

      if (this.filelistCapacidadEstanque.length) {
        bodyInfoDespacho.archivosCertificacionCapacidadEstanque = this.filelistCapacidadEstanque.map((o: IFileUpload) => ({
          nombre: o.name,
          tipo: o.nativeFile.type,
        }));
      }

      if (this.filelistTipoEstanque.length) {
        bodyInfoDespacho.archivosCertificacionTipoEstanque = this.filelistTipoEstanque.map((o: IFileUpload) => ({
          nombre: o.name,
          tipo: o.nativeFile.type,
        }));
      }

      console.log('🚀 ~ ExpressRetailFormComponent ~ handleSubmitInfoDespacho ~ bodyInfoDespacho:', bodyInfoDespacho);



      console.log(this.infoFacturacionForm.value);

      // Facturación
      let direccion = this.infoFacturacionForm.get('direccion').value;
      let razonSocial = this.infoPersonalForm.get('nombre').value;
      let rut = this.infoPersonalForm.get('rut').value?.replace(/\./g, '');

      let giro = 'Ventas al por menor de combustible';
      //let segmento = 'Ventas al por menor de combustible';
      let segmento = '50.50';

      if (this.infoFacturacionForm.get('mismaDireccion').value === true) {
        direccion = this.infoDespachoForm.get('direccion').value;
      }

      if (this.infoFacturacionForm.get('tipoPersona').value === 'Comercial') {
        razonSocial = this.infoFacturacionForm.get('razonSocial').value;
        rut = this.infoFacturacionForm.get('rut').value?.replace(/\./g, '');
        giro = this.infoFacturacionForm.get('giro').value;
        segmento = this.infoFacturacionForm.get('segmento').value?.codigo;
      }

      const bodyInfoFacturacion: any = {
        tipoCliente: this.infoFacturacionForm.get('tipoPersona').value,
        razonSocial: razonSocial,
        rutEmpresa: rut,
        direccionFacturacion: direccion,
        giroComercial: giro,
        segmento: segmento,
      };


      const bodyToSend = {
        informacionPersonal: bodyInfoPersonal,
        informacionDespacho: bodyInfoDespacho,
        informacionFacturacion: bodyInfoFacturacion,
        recaptchaResponse:  this.infoFacturacionForm.get('recaptchaReactive').value
      }
      console.log('🚀 ~ ExpressRetailFormComponent ~ handleSubmitInfoFacturacion ~ bodyToSend:', bodyToSend);

      // Formulario final
      const formData = new FormData();
      formData.append('jsonRequest', JSON.stringify(bodyToSend));
      formData.append('fileEstanque', this.filelistFotosEstanque[0]?.nativeFile);
      
      if (this.filelistCapacidadEstanque.length) {
        this.filelistCapacidadEstanque.forEach((o: IFileUpload, index: number) => {
          const label = `fileTc4-${index + 1}`;
          formData.append(label, o?.nativeFile);
        });
      }

      if (this.filelistTipoEstanque.length) {
        this.filelistTipoEstanque.forEach((o: IFileUpload, index: number) => {
          const label = `fileTc8-${index + 1}`;
          formData.append(label, o?.nativeFile);
        });
      }

      try {
        this.isLoading = true;
        const response = await this.clienteExpressService.saveForm(formData);
        this.paginaActual = 4;
      } catch (error) {
        console.error('error al enviar el formulario', error);
        this.isError = true;
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    }
  }


  public goToPage(index: number) {    
    if (this.paginaActual > index) {

      this.paginaActual = index;

      if (index === 2) {
        setTimeout(() => {
          this.loadMapDespacho();
        }, 100);
      }
      
    } else if (this.paginaActual < index) {
      if (this.paginaActual === 1) {
        this.handleSubmitInfoPersonal();
      } else if (this.paginaActual === 2) {
        this.handleSubmitInfoDespacho();
      }
    }
  }

  public goToLogin() {
    this.router.navigate(["auth"]);
  }





  private validateDespachoFiles() {

    this.errorFilesDespacho.fotosEstanque = this.filelistFotosEstanque.length === 0;
    this.errorFilesDespacho.capacidadEstanque = this.isShowCertificacionCapacidadEstanque ? this.filelistCapacidadEstanque.length === 0 : false;
    this.errorFilesDespacho.tipoEstanque = this.isShowTipoTanqueEstanque ? this.filelistTipoEstanque.length === 0 : false;

    return !this.errorFilesDespacho.fotosEstanque && !this.errorFilesDespacho.capacidadEstanque && !this.errorFilesDespacho.tipoEstanque;


  }
}
